module.exports = __webpack_public_path__ + "images/emoji/clock12.8b2bf30b4b57c4f9cbc6.png";